import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PartnersRoutingModule } from './partners-routing.module';
import { CheckPartnerCodeComponent } from './pages/check-partner-code/check-partner-code.component';
import { SharedModule } from '@app/shared/shared.module';
import { PartnerDiscountDetailsBannerComponent } from './components/partner-discount-details-banner/partner-discount-details-banner.component';

@NgModule({
  declarations: [CheckPartnerCodeComponent, PartnerDiscountDetailsBannerComponent],
  imports: [CommonModule, PartnersRoutingModule, SharedModule],
  exports: [PartnerDiscountDetailsBannerComponent],
})
export class PartnersModule {}
